import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { XaraLogoAnimated } from '../../theme/icons';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	root: {
		width: '100%',
		height: '100%'
	},
	preloader: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)'
	},
	title: {
		display: 'block',
		fontSize: '22px',
		lineHeight: '25px',
		fontWeight: 'bold',
		margin: '30px 0 0',
		opacity: 1,
		textAlign: 'center'
	},
	xaraLogo: {
		width: '84px',
		height: '25px',
		margin: '0 auto',
		display: 'block',
		color: theme.palette.colors.alpha
	}	
});

@withStyles(styles)
class ProcessingOrder extends Component {

	render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<div className={classes.preloader}>
					<XaraLogoAnimated className={classes.xaraLogo} />

					<Typography variant='h2' className={classes.title}>
						{localize('processing-order')}
					</Typography>
				</div>
			</div>
		);
	}

}

ProcessingOrder.propTypes = {
	classes: PropTypes.object
};

export default ProcessingOrder;


// WEBPACK FOOTER //
// ./src/components/ProcessingOrder/ProcessingOrder.js